/** Voucher Active/Used status UI — merged into non-English panel locales. */
export const panelVoucherStatusByLang = {
  es: {
    'user.deposit.voucher.statusActive': 'Activo',
    'user.deposit.voucher.statusUsed': 'Usado',
    'user.deposit.voucher.usedNote': 'Este cupón ya fue canjeado.',
    'user.deposit.voucher.myIssuedTitle': 'Mis cupones emitidos',
    'user.deposit.voucher.emptyIssued': 'Aún no has emitido cupones.',
    'user.deposit.voucher.loadingIssued': 'Cargando tus cupones…',
    'user.deposit.voucher.pinOnceHint':
      'El PIN se mostró una sola vez al generar el cupón. Compártelo desde tu copia guardada.',
  },
  de: {
    'user.deposit.voucher.statusActive': 'Aktiv',
    'user.deposit.voucher.statusUsed': 'Verwendet',
    'user.deposit.voucher.usedNote': 'Dieser Gutschein wurde bereits eingelöst.',
    'user.deposit.voucher.myIssuedTitle': 'Meine ausgestellten Gutscheine',
    'user.deposit.voucher.emptyIssued': 'Sie haben noch keine Gutscheine ausgestellt.',
    'user.deposit.voucher.loadingIssued': 'Gutscheine werden geladen…',
    'user.deposit.voucher.pinOnceHint':
      'Die PIN wurde nur einmal bei der Erstellung angezeigt. Teilen Sie Ihre gespeicherte Kopie.',
  },
  fr: {
    'user.deposit.voucher.statusActive': 'Actif',
    'user.deposit.voucher.statusUsed': 'Utilisé',
    'user.deposit.voucher.usedNote': 'Ce bon a déjà été échangé.',
    'user.deposit.voucher.myIssuedTitle': 'Mes bons émis',
    'user.deposit.voucher.emptyIssued': 'Vous n’avez pas encore émis de bons.',
    'user.deposit.voucher.loadingIssued': 'Chargement de vos bons…',
    'user.deposit.voucher.pinOnceHint':
      'Le PIN n’a été affiché qu’une fois à la création. Partagez votre copie enregistrée.',
  },
  ar: {
    'user.deposit.voucher.statusActive': 'نشط',
    'user.deposit.voucher.statusUsed': 'مُستخدم',
    'user.deposit.voucher.usedNote': 'تم استرداد هذه القسيمة بالفعل.',
    'user.deposit.voucher.myIssuedTitle': 'قسائمي الصادرة',
    'user.deposit.voucher.emptyIssued': 'لم تصدر أي قسائم بعد.',
    'user.deposit.voucher.loadingIssued': 'جاري تحميل قسائمك…',
    'user.deposit.voucher.pinOnceHint':
      'ظهر رمز PIN مرة واحدة فقط عند الإنشاء. شارك من نسختك المحفوظة.',
  },
  ja: {
    'user.deposit.voucher.statusActive': '有効',
    'user.deposit.voucher.statusUsed': '使用済み',
    'user.deposit.voucher.usedNote': 'このバウチャーはすでに利用されています。',
    'user.deposit.voucher.myIssuedTitle': '発行したバウチャー',
    'user.deposit.voucher.emptyIssued': 'まだバウチャーを発行していません。',
    'user.deposit.voucher.loadingIssued': 'バウチャーを読み込み中…',
    'user.deposit.voucher.pinOnceHint':
      'PINは発行時に一度だけ表示されました。保存したコピーから共有してください。',
  },
  ko: {
    'user.deposit.voucher.statusActive': '사용 가능',
    'user.deposit.voucher.statusUsed': '사용됨',
    'user.deposit.voucher.usedNote': '이 바우처는 이미 사용되었습니다.',
    'user.deposit.voucher.myIssuedTitle': '내가 발급한 바우처',
    'user.deposit.voucher.emptyIssued': '아직 발급한 바우처가 없습니다.',
    'user.deposit.voucher.loadingIssued': '바우처 불러오는 중…',
    'user.deposit.voucher.pinOnceHint':
      'PIN은 발급 시 한 번만 표시됩니다. 저장해 둔 복사본으로 공유하세요.',
  },
  'zh-CN': {
    'user.deposit.voucher.statusActive': '有效',
    'user.deposit.voucher.statusUsed': '已使用',
    'user.deposit.voucher.usedNote': '此券已被兑换。',
    'user.deposit.voucher.myIssuedTitle': '我发行的券',
    'user.deposit.voucher.emptyIssued': '您还没有发行任何券。',
    'user.deposit.voucher.loadingIssued': '正在加载您的券…',
    'user.deposit.voucher.pinOnceHint': 'PIN 仅在生成时显示一次。请使用您保存的副本分享。',
  },
  pt: {
    'user.deposit.voucher.statusActive': 'Ativo',
    'user.deposit.voucher.statusUsed': 'Usado',
    'user.deposit.voucher.usedNote': 'Este voucher já foi resgatado.',
    'user.deposit.voucher.myIssuedTitle': 'Meus vouchers emitidos',
    'user.deposit.voucher.emptyIssued': 'Você ainda não emitiu vouchers.',
    'user.deposit.voucher.loadingIssued': 'Carregando seus vouchers…',
    'user.deposit.voucher.pinOnceHint':
      'O PIN foi exibido apenas uma vez na geração. Compartilhe a partir da sua cópia salva.',
  },
  it: {
    'user.deposit.voucher.statusActive': 'Attivo',
    'user.deposit.voucher.statusUsed': 'Usato',
    'user.deposit.voucher.usedNote': 'Questo voucher è già stato riscattato.',
    'user.deposit.voucher.myIssuedTitle': 'I miei voucher emessi',
    'user.deposit.voucher.emptyIssued': 'Non hai ancora emesso voucher.',
    'user.deposit.voucher.loadingIssued': 'Caricamento voucher…',
    'user.deposit.voucher.pinOnceHint':
      'Il PIN è stato mostrato una sola volta alla generazione. Condividi dalla copia salvata.',
  },
  ru: {
    'user.deposit.voucher.statusActive': 'Активен',
    'user.deposit.voucher.statusUsed': 'Использован',
    'user.deposit.voucher.usedNote': 'Этот ваучер уже был погашен.',
    'user.deposit.voucher.myIssuedTitle': 'Мои выпущенные ваучеры',
    'user.deposit.voucher.emptyIssued': 'Вы ещё не выпускали ваучеры.',
    'user.deposit.voucher.loadingIssued': 'Загрузка ваучеров…',
    'user.deposit.voucher.pinOnceHint':
      'PIN показывался только один раз при создании. Делитесь сохранённой копией.',
  },
  bn: {
    'user.deposit.voucher.statusActive': 'সক্রিয়',
    'user.deposit.voucher.statusUsed': 'ব্যবহৃত',
    'user.deposit.voucher.usedNote': 'এই ভাউচার ইতিমধ্যে রিডিম হয়েছে।',
    'user.deposit.voucher.myIssuedTitle': 'আমার ইস্যু করা ভাউচার',
    'user.deposit.voucher.emptyIssued': 'আপনি এখনও কোনো ভাউচার ইস্যু করেননি।',
    'user.deposit.voucher.loadingIssued': 'ভাউচার লোড হচ্ছে…',
    'user.deposit.voucher.pinOnceHint':
      'পিন শুধু তৈরির সময় একবার দেখানো হয়েছিল। সংরক্ষিত কপি থেকে শেয়ার করুন।',
  },
  hi: {
    'user.deposit.voucher.statusActive': 'सक्रिय',
    'user.deposit.voucher.statusUsed': 'उपयोग हो चुका',
    'user.deposit.voucher.usedNote': 'यह वाउचर पहले ही रिडीम हो चुका है।',
    'user.deposit.voucher.myIssuedTitle': 'मेरे जारी किए वाउचर',
    'user.deposit.voucher.emptyIssued': 'आपने अभी तक कोई वाउचर जारी नहीं किया।',
    'user.deposit.voucher.loadingIssued': 'वाउचर लोड हो रहे हैं…',
    'user.deposit.voucher.pinOnceHint':
      'PIN केवल बनाते समय एक बार दिखाया गया था। सहेजी प्रति से साझा करें।',
  },
};
